(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.handleDetailsToggle()
    }

    handleDetailsToggle() {
      const navHeader = this.header;
      const navDetails = this.querySelectorAll('details');

      const updateMenuOpenClass = () => {
        const anyOpen = Array.from(navDetails).some(detail => detail.open);
        if (anyOpen) {
          navHeader.classList.add('menu-open');
        } else {
          navHeader.classList.remove('menu-open');
        }
      };

      navDetails.forEach(detail => {
        detail.addEventListener("toggle", updateMenuOpenClass);
      });

      // Initial check in case any details are already open
      updateMenuOpenClass();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      const blurDiv = document.querySelector("#blur-effect-div")

      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      blurDiv?.classList.remove("top-0");
      blurDiv?.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      const blurDiv = document.querySelector("#blur-effect-div")
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      blurDiv?.classList.add('shopify-section-header-sticky', 'animate');
      blurDiv?.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());

    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  // Account dropdown click toggle
  const accountMenus = document.querySelectorAll('.account-menu');

  accountMenus.forEach((menu) => {
    const trigger = menu.querySelector('.account-menu__trigger');
    const dropdown = menu.querySelector('.account-dropdown');

    if (!trigger || !dropdown) return;

    // Move dropdown outside the blended header
    if (dropdown.parentNode !== document.body) {
      document.body.appendChild(dropdown);
    }

    const positionDropdown = () => {
      const rect = trigger.getBoundingClientRect();
      const dropdownWidth = dropdown.offsetWidth || 180;
      const viewportPadding = 12;

      let left = rect.right - dropdownWidth;

      if (left < viewportPadding) {
        left = viewportPadding;
      }

      if (left + dropdownWidth > window.innerWidth - viewportPadding) {
        left = window.innerWidth - dropdownWidth - viewportPadding;
      }

      dropdown.style.left = `${left}px`;
      dropdown.style.top = `${rect.bottom + 12}px`;
    };

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = !dropdown.classList.contains('is-open');

      // Close all other dropdowns
      document.querySelectorAll('.account-dropdown.is-open').forEach((d) => {
        d.classList.remove('is-open');
      });

      document.querySelectorAll('.account-menu__trigger').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });

      if (isOpen) {
        positionDropdown();
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    window.addEventListener('resize', () => {
      if (dropdown.classList.contains('is-open')) {
        positionDropdown();
      }
    });

    window.addEventListener('scroll', () => {
      if (dropdown.classList.contains('is-open')) {
        positionDropdown();
      }
    });
  });

  document.addEventListener('click', () => {
    document.querySelectorAll('.account-dropdown').forEach((dropdown) => {
      dropdown.classList.remove('is-open');
    });

    document.querySelectorAll('.account-menu__trigger').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.account-dropdown').forEach((dropdown) => {
      dropdown.classList.remove('is-open');
    });

    document.querySelectorAll('.account-menu__trigger').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
  });

  // js for desktop cart drawer
  let desktop_icon = document.querySelector(".desktop-cart-icon");
  let cart_type_attribute = desktop_icon.getAttribute("cart-type-attribute");
    desktop_icon.addEventListener("click", function(e) {
      if (cart_type_attribute === "drawer" && _GiftData?.template !== "cart") {
        e.preventDefault();
        let drawer = document.querySelector(".drawer");
        drawer.classList.add("active");
      }
    });

  } catch(e) { console.error(e); }
})();
})();
